import { Grid, Tooltip, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import ControlledCheckBox from 'src/shared/components/form/controlledCheckbox';
import { AdditionalServiceTypeEnum } from 'src/shared/models/enums/additionalServiceType.enum';
import { InfoOutlined } from '@mui/icons-material';

type AdditionalServiceInfoItem = {
  type: AdditionalServiceTypeEnum;
  description: string;
};

const additionalServicesInfoList: AdditionalServiceInfoItem[] = [
  {
    type: AdditionalServiceTypeEnum.Autogiro,
    description: 'customer:detailPage.additionalServices.autogiroDescription',
  },
  {
    type: AdditionalServiceTypeEnum.OwnPayment,
    description: 'customer:detailPage.additionalServices.ownPaymentDescription',
  },
  {
    type: AdditionalServiceTypeEnum.ActivateSpar,
    description: 'customer:detailPage.additionalServices.activateSparDescription',
  },
  {
    type: AdditionalServiceTypeEnum.SupportPlus,
    description: 'customer:detailPage.additionalServices.supportPlusDescription',
  },
];

export const CustomerSettingsAdditionalServices = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const additionalServicesInfo = (serviceType: AdditionalServiceTypeEnum) => {
    const service = additionalServicesInfoList.find((s) => s.type === serviceType);

    return t(`${service?.description}`) || '';
  };

  return (
    <>
      <Typography mb={2} sx={{ fontWeight: 500, color: 'text.secondary' }}>
        {t('customer:detailPage.additionalServices.title')}
      </Typography>
      <Grid container spacing={1} px={1}>
        <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, sm: 0 } }}>
          <ControlledCheckBox
            disabled
            clickOnlyOnBox
            name='newsPaper5'
            value={watch('newsPaper5')}
            label={<Trans i18nKey='customer:detailPage.additionalServices.autogiro' />}
          />
          <Tooltip title={additionalServicesInfo(AdditionalServiceTypeEnum.Autogiro)} arrow>
            <InfoOutlined sx={{ ml: -1, color: 'text.disabled', cursor: 'default', opacity: 0.9 }} />
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, sm: 0 } }}>
          <ControlledCheckBox
            disabled
            clickOnlyOnBox
            name='newsPaper2'
            value={watch('newsPaper2')}
            label={<Trans i18nKey='customer:detailPage.additionalServices.ownPayment' />}
          />
          <Tooltip title={additionalServicesInfo(AdditionalServiceTypeEnum.OwnPayment)} arrow>
            <InfoOutlined sx={{ ml: -1, color: 'text.disabled', cursor: 'default', opacity: 0.9 }} />
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, sm: 0 } }}>
          <ControlledCheckBox
            disabled
            clickOnlyOnBox
            name='newsPaper4'
            value={watch('newsPaper4')}
            label={<Trans i18nKey='customer:detailPage.additionalServices.activateSpar' />}
          />
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, sm: 0 } }}>
          <ControlledCheckBox
            disabled
            clickOnlyOnBox
            name='newsPaper'
            value={watch('newsPaper')}
            label={<Trans i18nKey='customer:detailPage.additionalServices.supportPlus' />}
          />
          <Tooltip title={additionalServicesInfo(AdditionalServiceTypeEnum.SupportPlus)} arrow>
            <InfoOutlined sx={{ ml: -1, color: 'text.disabled', cursor: 'default', opacity: 0.9 }} />
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};
